import React from 'react';
import ReactDOM from 'react-dom';

import Range from './react-range';
class Audioslider extends React.Component{

	constructor(props){
		super(props);
	}
	render(){
		return (
			<div className="slider">
				<label htmlFor={'input-'+this.props.name}>{this.props.name}</label>
				<Range
				  className='slider'
				  onChange={(event) => this.props.onChange(event)}
				  name={this.props.name} 
				  id={'input-'+this.props.name}
				  type='range'
				  value={this.props.value}
				  min={0}
				  max={1}
				  step={.01} />
				
			</div>
			);

	}
}

export default Audioslider;


// WEBPACK FOOTER //
// ./src/scripts/audioslider.js